const normalize = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function matchesPayrollSearch(row, query) {
  let text = normalize(query).trim();
  if (!text) return true;
  const conditions = [
    [/\b(?:no tax card|without tax card|intet skattekort)\b/g, row.taxCardReceived === false],
    [/\b(?:with tax card|tax card|skattekort)\b/g, row.taxCardReceived === true],
    [/\bdanl[oø]n inactive\b/g, row.danlonActive === false],
    [/\bdanl[oø]n active\b/g, row.danlonActive === true],
    [/\b(?:tempus )?(?:inactive|inaktiv)\b/g, row.tempusActive === false],
    [/\b(?:tempus )?(?:active|aktiv)\b/g, row.tempusActive === true],
  ];
  for (const [pattern, matches] of conditions) {
    if (text.match(pattern)) {
      if (!matches) return false;
      text = text.replace(pattern, ' ').trim();
    }
  }
  const words = [row.name, row.cpr, String(row.cpr || '').replace(/\D/g, ''), row.medarbNr, row.note,
    row.tempusActive ? 'active aktiv' : 'inactive inaktiv',
    row.danlonActive === true ? 'danlon active' : row.danlonActive === false ? 'danlon inactive' : 'danlon unknown',
    row.employedInMonth ? 'employed ansat' : 'former tidligere',
    row.vacationTaken ? 'vacation ferie' : '',
    ...(row.placements || []).map((p) => p.customerName || p.customer?.companyName || p.customer?.name || ''),
    ...(row.customers || []).map((c) => c.name || c.companyName || ''),
    ...Object.values(row).filter((v) => typeof v === 'number').flatMap((v) => [v, v.toLocaleString('da-DK')]),
  ].map(normalize).join(' ');
  return words.includes(text.replace(/\s+/g, ' '));
}
